import {PagedMetadata} from '@generated/models'

export type {
  ApiStatusDtoWithTimeStamp as ApiStatus,
  ExactOrEstimatedDateDto as ExactOrEstimatedDate,
  PagedMetadata as PagingData,
  SimpleResponse,
} from '@generated/models'

export type GeneralPagedReponse = {
  page: PagedMetadata
}

export type RecordsSorting = {
  sorted: boolean
}

export type PagedResponse<T> = {
  page: PagedMetadata
  records: T[]
  sorting?: RecordsSorting
}

// Re-exports of generated enums/types used across normalisers
export {DayOfWeek} from '@generated/models'
